import type { PricingBand, PricingValues } from '@/types';

const dayLabels: Record<string, string> = {
  mon: '周一',
  tue: '周二',
  wed: '周三',
  thu: '周四',
  fri: '周五',
  sat: '周六',
  sun: '周日',
};

function formatThresholdOperator(operator?: string) {
  switch (operator) {
    case 'gt':
      return '>';
    case 'gte':
      return '≥';
    case 'lt':
      return '<';
    case 'lte':
      return '≤';
    case 'eq':
      return '=';
    default:
      return operator || '?';
  }
}

export function describePricingBand(band: PricingBand) {
  if (band.default) return '默认档位';
  const match = band.match;
  if (!match) return '未配置条件';
  if (match.mode === 'time_schedule') {
    const timezone = match.params?.timezone || 'UTC';
    const windows = match.params?.windows || [];
    const days = match.params?.days_of_week || [];
    const dayText = days.length
      ? `${days.map((day) => dayLabels[day.toLowerCase()] || day).join('、')} · `
      : '';
    const schedule = windows
      .map((window) => `${window.start}–${window.end}`)
      .join('、');
    return `${dayText}${timezone} ${schedule || '未配置时段'}`;
  }
  if (match.mode === 'context_token_threshold') {
    const operator = formatThresholdOperator(match.params?.operator);
    const value = match.params?.value;
    return `上下文 tokens ${operator} ${typeof value === 'number' ? value.toLocaleString() : '?'}`;
  }
  return `模式：${match.mode}`;
}

export function resolvePricingValue(
  prices: PricingValues,
  basePrices: PricingValues,
  key: keyof PricingValues,
) {
  if (prices[key] != null) {
    return { value: prices[key], inherited: false };
  }
  return { value: basePrices[key], inherited: basePrices[key] != null };
}
